module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"map":"Карта","vizualization":"Визуализация","editor":"Редактор геометрии"},"en":{"map":"Map","vizualization":"Vizualization","editor":"Geometry Editor"}}')
  delete Component.options._Ctor
}
